import { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, ArrowLeft, ExternalLink, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

const TOOL_LABEL = { consulenza: "Chiavi in mano", bolletta: "Carica la bolletta", tetto: "Misura il tetto", colonnina: "Stazione di ricarica" };

export default function ConfiguratoreFrame() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tool = params.get("tool") || "";
  const moduleId = params.get("module") || "";
  const configId = params.get("config_id") || "";
  const [url, setUrl] = useState(null);
  const [name, setName] = useState("");
  const [err, setErr] = useState(null);

  useEffect(() => {
    setUrl(null); setErr(null);
    api.post("/rete/launch", { installer_id: id, tool, module_listino_id: moduleId || undefined, config_id: configId || undefined })
      .then((r) => { setUrl(r.data.url); setName(r.data.name || ""); })
      .catch((e) => setErr(formatApiError(e.response?.data?.detail) || "Impossibile aprire il configuratore"));
  }, [id, tool, moduleId, configId]);

  return (
    <div className="flex h-[calc(100vh-3rem)] flex-col gap-3" data-testid="configuratore-frame-page">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="cfg-back"><ArrowLeft className="mr-2 h-4 w-4" /> Indietro</Button>
          <h1 className="font-heading text-xl font-black tracking-tight">
            Configuratore{name ? ` · ${name}` : ""}{tool && TOOL_LABEL[tool] ? ` · ${TOOL_LABEL[tool]}` : ""}
          </h1>
        </div>
        {url && <a href={url} target="_blank" rel="noreferrer"><Button variant="outline" size="sm" data-testid="cfg-open-tab"><ExternalLink className="mr-2 h-4 w-4" /> Apri in una nuova scheda</Button></a>}
      </div>
      {err ? (
        <div className="flex flex-1 flex-col items-center justify-center gap-2 rounded-lg border border-destructive/40 bg-destructive/5 text-center" data-testid="cfg-error">
          <AlertTriangle className="h-8 w-8 text-destructive" />
          <div className="font-semibold">{err}</div>
        </div>
      ) : !url ? (
        <div className="flex flex-1 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
      ) : (
        <iframe src={url} title="Configuratore Torri" className="flex-1 w-full rounded-lg border border-border" data-testid="configuratore-iframe" allow="clipboard-write; geolocation" />
      )}
    </div>
  );
}
